// 中央配置ボタン
import React from 'react';
import { Button } from 'react-bootstrap';

interface Props {
  label: string;
  handleClick?: React.MouseEventHandler<HTMLButtonElement>;
  btn_class?: string;
  is_disabled?: boolean;
}

const CenterButton: React.FC<Props> = ({ label, handleClick, btn_class, is_disabled = false }) => {
  if (typeof handleClick === 'undefined') {
    // エラー防止:ハンドラの指定がない場合は空のハンドラを設定する
    handleClick = () => {};
  }

  return (
    <div className="center-button">
      <Button
        // ボタンのクリック設定
        onClick={handleClick}
        className={`btn-max ${btn_class}`}
        size="lg"
        variant="custom"
        disabled={is_disabled}
      >
        {label}
      </Button>
    </div>
  );
};

export default CenterButton;
